import React from 'react';
import { Skeleton as AntdSkeleton } from 'antd';
import { Overlay } from './overlay';
/**
 * A skeleton placeholder component to save space
 * while content is loading
 *
 * {@link https://ant.design/components/skeleton#skeleton}
 *
 * @module Skeleton
 * @param {Object} props - the skeleton props
 * @param {boolean} [props.active] - whether the skeleton is active
 * @returns {React.ReactElement} The rendered skeleton
*/
const Skeleton = ( { children, ...props } ) => {
    // make active the default
    const active = props.active === undefined || props.active;
    return (
        <AntdSkeleton { ...props } active={ active }>
            { children }
        </AntdSkeleton>
    );
};

Skeleton.Button = AntdSkeleton.Button;
Skeleton.Avatar = AntdSkeleton.Avatar;
Skeleton.Input = AntdSkeleton.Input;
Skeleton.Image = AntdSkeleton.Image;
Skeleton.Node = AntdSkeleton.Node;
Skeleton.Overlay = Overlay;

export { Skeleton };
